import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

import { t } from '@/plugins/i18n'
import { isMultiStore } from '@/store'
import { nextTick, onBeforeMount, onMounted, ref, computed, withDefaults } from 'vue'
import { ElSelect, ElOption, ElFormItem, ElForm } from 'element-plus'
import { ShopPurchaseRespDTO } from '@/service/customer'

export default /*#__PURE__*/_defineComponent({
  props: {
    config: { type: null, required: false },
    isTiktok: { type: Boolean, required: false, default: false },
    list: { type: null, required: true, default: {
    cn: [],
    kr: [],
    jp: []
  } },
    item: { type: null, required: true, default: { intShipConfigId: null } }
  },
  emits: ['changeIntShip', 'changeIntShipBach'],
  setup(__props: any, { emit: emits }) {

const props = __props as { config?: ShopPurchaseRespDTO, isTiktok: boolean, list: any, item: any }



const intShipConfigId: any = ref()
const intShipConfigIdCn: any = ref()
const intShipConfigIdKr: any = ref()
const intShipConfigIdJp: any = ref()
// const isbatch: any = ref(false)

onBeforeMount(() => {
  intShipConfigId.value = props.item.intShipConfigId ? props.item.intShipConfigId : ''
})

const changeSelect = (val: string) => {
  const tmpcountryCode = props.item[0]?.receiver?.countryCode || props.item.receiver?.countryCode

  const shopOrderIds = props.item.map((d: { shopOrderId: any }) => d.shopOrderId)
  emits('changeIntShipBach', {
    cn: intShipConfigIdCn.value,
    kr: intShipConfigIdKr.value,
    jp: intShipConfigIdJp.value
  }, shopOrderIds, tmpcountryCode)
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(ElForm), null, {
    default: _withCtx(() => [
      (( __props.config?.deliveryType != 'ONLY_JP') )
        ? (_openBlock(), _createBlock(_unref(ElFormItem), {
            key: 0,
            label: __props.config?.allowMutiWareHouseDelivery || (__props.config?.deliveryType == 'ONLY_JP') || _unref(isMultiStore)() ? _unref(t)('中国仓商品物流配置') : _unref(t)('国际物流配置'),
            "custom-class": "Expresses-item"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(ElSelect), {
                modelValue: intShipConfigIdCn.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((intShipConfigIdCn).value = $event)),
                filterable: "",
                placeholder: _unref(t)('请选择物流公司'),
                onChange: changeSelect
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.list.cn, (item) => {
                    return (_openBlock(), _createBlock(_unref(ElOption), {
                      key: item.intShipConfigId,
                      label: item.distribution,
                      value: item.intShipConfigId
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue", "placeholder"])
            ]),
            _: 1
          }, 8, ["label"]))
        : _createCommentVNode("", true),
      (_unref(isMultiStore)())
        ? (_openBlock(), _createBlock(_unref(ElFormItem), {
            key: 1,
            label: _unref(t)('韩国仓商品物流配置'),
            "custom-class": "Expresses-item"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(ElSelect), {
                modelValue: intShipConfigIdKr.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((intShipConfigIdKr).value = $event)),
                filterable: "",
                placeholder: _unref(t)('请选择物流公司'),
                onChange: changeSelect
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.list.kr, (item) => {
                    return (_openBlock(), _createBlock(_unref(ElOption), {
                      key: item.intShipConfigId,
                      label: item.distribution,
                      value: item.intShipConfigId
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue", "placeholder"])
            ]),
            _: 1
          }, 8, ["label"]))
        : _createCommentVNode("", true),
      ((__props.config?.allowMutiWareHouseDelivery || __props.config?.deliveryType === 'ONLY_JP'))
        ? (_openBlock(), _createBlock(_unref(ElFormItem), {
            key: 2,
            label: _unref(t)('日本仓商品物流配置'),
            "custom-class": "Expresses-item"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(ElSelect), {
                modelValue: intShipConfigIdJp.value,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((intShipConfigIdJp).value = $event)),
                filterable: "",
                placeholder: _unref(t)('请选择物流公司'),
                onChange: changeSelect
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.list.jp, (item) => {
                    return (_openBlock(), _createBlock(_unref(ElOption), {
                      key: item.intShipConfigId,
                      label: item.distribution,
                      value: item.intShipConfigId
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue", "placeholder"])
            ]),
            _: 1
          }, 8, ["label"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})